import AWS from "../../componentLayer/pages/services/AWS";
import BusinessConsulting from "../../componentLayer/pages/services/BusinessConsulting";
import KapilTechnologies360Degrees from "../../componentLayer/pages/services/KapilTechnologies360Degrees";
import Google_Colud_Services from "../../componentLayer/pages/services/Google_Colud_Services";
import Infor from "../../componentLayer/pages/services/InforPage/InforPage.jsx";
import Microsoft from "../../componentLayer/pages/services/Microsoft";
import Oddo from "../../componentLayer/pages/services/Oddo";
import Oracle_ID_Edwards from "../../componentLayer/pages/services/Oracle_ID_Edwards";
import Easychits from "../../componentLayer/pages/services/Products/Easychits";
import Finsta from "../../componentLayer/pages/services/Products/Finsta/FinstaHome/Finsta";
import IFCA from "../../componentLayer/pages/services/Products/IFCA";
import MES from "../../componentLayer/pages/services/Products/MESINFOR/MESInfor";
import MPDV from "../../componentLayer/pages/services/Products/MPDV";
import SampleTemp from "../../componentLayer/pages/services/SampleTemp";
import SAP from "../../componentLayer/pages/services/SAP/SAP";
import PLM from "../../componentLayer/pages/services/PLM";
import SupplyChainManagement from "../../componentLayer/pages/services/SupplyChainManagement";
import ESG from "../../componentLayer/pages/services/ESG";
import ITTransformation from "../../componentLayer/pages/services/ITTransformation";
import ApplicationManagement from "../../componentLayer/pages/services/ApplicationManagement";
import GenerativeAI from "../../componentLayer/pages/services/NewServices/AIGenerativeAI/GenerativeAI";
import AIDevelopment from "../../componentLayer/pages/services/NewServices/AIDevelopment/AIDevelopment";
import CloudMigrationManagedServices from "../../componentLayer/pages/services/NewServices/CloudMigrationManagedServices/CloudMigrationManagedServices";
import EnterpriseSoftwareConsulting from "../../componentLayer/pages/services/NewServices/EnterpriseSoftwareConsulting/EnterpriseSoftwareConsulting";
import CybersecurityServices from "../../componentLayer/pages/services/NewServices/Cybersecurity/CybersecurityServices";
import StaffAugmentationManagedServices from "../../componentLayer/pages/services/NewServices/StaffAugmentationManagedServices/StaffAugmentationManagedServices";
import Testing from "../../componentLayer/pages/services/Testing";
import Development from "../../componentLayer/pages/services/servicesInnerPages/Development";
import Office24by7 from '../../componentLayer/pages/services/Products/Office24by7/Office24by7'
import Prokraya from '../../componentLayer/pages/services/Products/Prokraya/Prokraya'

// Infor 
import InforCSI  from "../../componentLayer/pages/services/Infor/ERP Solutions/InforCSI"
import InforLN from "../../componentLayer/pages/services/Infor/ERP Solutions/InforLN";
import InforM3 from "../../componentLayer/pages/services/Infor/ERP Solutions/inforM3";
// supplychain
import InforSupplyChain from "../../componentLayer/pages/services/Infor/SupplyChainPlanning/InforSupplyChain";
// warehouse
import InforWMSLanding from "../../componentLayer/pages/services/Infor/WareHouseManagement/InforWareHouseManagement";
//CoustomerExpereince
import InforCPQShowcase from "../../componentLayer/pages/services/Infor/CoustomerExperience/InforCPQ";
import InforCRMComponent from "../../componentLayer/pages/services/Infor/CoustomerExperience/InforCRM";
import InforRhythmLanding from "../../componentLayer/pages/services/Infor/CoustomerExperience/InforRhythemForComerce";
// PLM
import InforPLMProcess from '../../componentLayer/pages/services/Infor/ProductLifeCycle/InforPLMforProcess'
import InforPLMFashion from "../../componentLayer/pages/services/Infor/ProductLifeCycle/InforPLMforFashion";
//os
import InforOSDashboard from "../../componentLayer/pages/services/Infor/InforOS/InforOS";
//Mobillor
import InforMobillor from "../../componentLayer/pages/services/Mobillor";
import Mobillor from "../../componentLayer/pages/services/Mobillor";
//crm
import CRM from "../../componentLayer/pages/services/CRM";
//Bsfi
import BSFI from "../../componentLayer/pages/services/BSFI";
// Consulting — AI, security, GenAI
import ConsultingServicePage from "../../componentLayer/pages/services/ConsultingServicePage";


export const serviceRouter = [
  {
    path: "ai-development",
    element: <AIDevelopment />,
  },
  {
    path: "digital",
    element: <SampleTemp />,
  },
  {
    path: "oracle_and_id_edwards",
    element: <Oracle_ID_Edwards />,
  },
  {
    path: "sap",
    element: <SAP />,
  },
  {
    path: "infor",
    element: <Infor />,
  },
  {
    path: "generative-ai-development",
    element: <GenerativeAI />,
  },
  {
    path: "cloud-migration-managed-services",
    element: <CloudMigrationManagedServices />,
  },
  {
    path: "enterprise-software-consulting",
    element: <EnterpriseSoftwareConsulting />,
  },
  {
    path: "staff-augmentation-managed-services",
    element: <StaffAugmentationManagedServices />,
  },
  {
    path: "microsoft",
    element: <Microsoft />,
  },
  {
    path: "odoo",
    element: <Oddo />,
  },
  {
    path: "mobillor",
    element: <Mobillor />,
  },
  {
    path: "aws",
    element: <AWS />,
  },
  {
    path: "googlecloud",
    element: <Google_Colud_Services />,
  },
  {
    path: "customer_relationship_management",
    element: <CRM />,
  },
  {
    path: "/services/bsfi",
    element: <BSFI />,
  },
  {
    path: "manufacturing_execution_systems",
    element: <BusinessConsulting />,
  },
  {
    path: "product_lifecycle_management",
    element: <PLM />,
  },
  {
    path: "supply_chain_management",
    element: <SupplyChainManagement />,
  },
  {
    path: "environmental_social_governance",
    element: <ESG />,
  },
  {
    path: "it_transformation",
    element: <ITTransformation />,
  },
  {
    path: "applications_management",
    element: <ApplicationManagement />,
  },
  {
    path: "testing",
    element: <Testing />,
  },
  {
    path: "ai_ml",
    element: <ConsultingServicePage serviceKey="ai_ml" />,
  },
  {
    path: "cybersecurity",
    element: <CybersecurityServices />,
  },
  {
    path: "agentic_ai",
    element: <ConsultingServicePage serviceKey="agentic_ai" />,
  },
  {
    path: "generative_ai",
    element: <ConsultingServicePage serviceKey="generative_ai" />,
  },
  {
    path: "development",
    element: <ApplicationManagement />,
  },
  {
    path: "hexabuilt",
    element: <BusinessConsulting />,
  },
  {
    path: "qrra",
    element: <BusinessConsulting />,
  },
  {
    path: "finsta",
    element: <Finsta />,
  },
  {
    path: "easychits",
    element: <Easychits />,
  },
  {
    path: "ifca",
    element: <IFCA />,
  },
  {
    path: "mes",
    element: <MES />,
  },
  {
    path: "mpdv",
    element: <MPDV />,
  },
  {
    path: "spa",
    element: <BusinessConsulting />,
  },
  {
    path: "mobillor",
    element: <BusinessConsulting />,
  },
  {
    path: "Office24by7",
    element: <Office24by7 />,
  },
  {
    path: "RantaiPro",
    element: <Prokraya />,
  },
  {
    path: "infor/csi",
    element: <InforCSI />,
  },
  {
    path: "infor/ln",
    element: <InforLN />,
  },
  {
    path: "infor/m3",
    element: <InforM3 />,
  },
  {
    path: "infor/mes",
    element: <MES />,
  },
  {
    path: "infor/wms",
    element: <InforWMSLanding />,
  },
  {
    path: "infor/os",
    element: <InforOSDashboard />,
  },
  {
    path: "SupplyChain/InforSupplyChain",
    element: <InforSupplyChain />,
  },

  {
    path: "CoustomerExperience/InforCPQ",
    element: <InforCPQShowcase />,
  },
  {
    path: "CoustomerExperience/InforCRM",
    element: <InforCRMComponent />,
  },
  {
    path: "CoustomerExperience/InforRhytm",
    element: <InforRhythmLanding />,
  },
  {
    path: "productLifeCycle/InforPLMFashion",
    element: <InforPLMFashion />,
  },
  {
    path: "productLifeCycle/InforPLMProcess",
    element: <InforPLMProcess />,
  },
  {
    path: "InforOS",
    element: <InforOSDashboard />,
  },
];

export const consultingServicesRouter = [
  {
    path: "development",
    element: <ApplicationManagement />,
  },
  {
    path: "testing",
    element: <Testing />,
  },
  {
    path: "customer_relationship_management",
    element: <CRM />,
  },
  {
    path: "ai_ml",
    element: <ConsultingServicePage serviceKey="ai_ml" />,
  },
  {
    path: "cybersecurity",
    element: <CybersecurityServices />,
  },
  {
    path: "agentic_ai",
    element: <ConsultingServicePage serviceKey="agentic_ai" />,
  },
  {
    path: "generative_ai",
    element: <ConsultingServicePage serviceKey="generative_ai" />,
  },
  {
    path: "sap",
    element: <SAP />,
  },
  {
    path: "odoo",
    element: <Oddo />,
  },
  {
    path: "infor",
    element: <Infor />,
  },
  {
    path: "microsoft",
    element: <Microsoft />,
  },
  {
    path: "oracle_and_id_edwards",
    element: <Oracle_ID_Edwards />,
  },
];
